<template>
  <div class="login-wrap">
    <div class="login_left"></div>
    <div class="login_right">
      <div class="login_logo"></div>
      <div class="ms_login">
        <div class="ms_title">欢迎登录</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <div class="ms_login-input-content">
            <el-form-item prop="username">
              <el-input prefix-icon="el-icon-user" v-model="ruleForm.username" placeholder="请输入账号"></el-input>
            </el-form-item>
          </div>
          <div class="ms_login-input-content">
            <el-form-item prop="password">
              <el-input prefix-icon="el-icon-lock" v-model="ruleForm.password" type="password" placeholder="请输入密码"
                @keyup.enter.native="submitForm('ruleForm')"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="password">
          <div class="save_password">
            <input type="checkbox" @click="savePassword" :checked="isChoose" class="check_box" />
            <div>记住密码</div>
          </div>
          <el-tooltip class="item linght_password" effect="light" content="如忘记密码请联系恁的上级管理员修改" placement="top">
            <div class="forget" @mouseover="clickMe">
              忘记密码
            </div>
          </el-tooltip>
          <div class="forget" title="如忘记密码请联系恁的上级管理员修改">
          </div>
        </div>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm('ruleForm')" size="medium" :disabled="loginDisabled">登录
          </el-button>
        </div>
      </div>
      <div class="addXuQiu" @click="addClick">
        <i class="el-icon-question"></i>
        <div>帮助</div>
      </div>
    </div>
  </div>
</template>
<script>
import GlobalUtil from "@/utils/globalUtil";

export default {
  data: function () {
    return {
      ruleForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "输入不能为空哦~", trigger: "blur" },
          { min: 6, max: 15, message: "长度在 6 到 15 个字符", trigger: "blur" }
        ],
        password: [
          { required: true, message: "输入不能为空哦~", trigger: "blur" }
        ]
      },
      activeName: "first",
      company: "云客派",
      disabled: true,
      loginDisabled: false,
      userName: "",
      passWord: "",
      codeText: "发送",
      flag: true,
      vCode: "",
      session: "",
      token: "",
      sig: "",
      isChoose: false
    };
  },
  created() {
    let choos = GlobalUtil.readCookie("isChoose") === 'true';
    if (choos && GlobalUtil.readCookie("save1") && GlobalUtil.readCookie("saveUsername")) {
      this.ruleForm.password = GlobalUtil.readCookie("save1");
      this.ruleForm.username = GlobalUtil.readCookie("saveUsername");
      this.isChoose = choos;
    }
  },
  mounted() {
    console.log(document.querySelector('.el-tooltip__popper'))
    // .classList.add('active_popper')
  },
  computed: {
    systemConfig() {
      return this.$store.state.systemConfig;
    }
  },
  methods: {
    clickMe() {
      //  console.log(document.querySelector('.el-tooltip__popper'))
      //  document.querySelector('.el-tooltip__popper').classList.add('active_popver')
    },
    getSystemConfig() {
      this.$store.dispatch("getSystemConfig");
    },
    enterSubmit() {
      if (this.loginDisabled) {
        return false;
      } else {
        this.submitForm();
      }
    },
    // 新增帮助点击事件
    addClick() {
      window.open('https://www.yuque.com/books/share/5450ff03-d28f-449c-a396-5899af721935?#', '_blank')
    },
    // 记住密码
    savePassword() {
      this.isChoose = !this.isChoose;
      console.log(this.isChoose);
    },
    // 登录点击事件
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //登录验证
          this.$axios.post(this.$url.loginByPwd, this.ruleForm).then(res => {
            if (res.code === 0) {

              localStorage.setItem('token', res.data.token);
              localStorage.setItem('entCode', res.data.entCode);
              GlobalUtil.setCookie("headers", res.data.token);
              GlobalUtil.setCookie("entCodeEq", res.data.entCode);
              GlobalUtil.setCookie("lastLoginDate", res.data.lastLoginDate);
              GlobalUtil.setCookie("username1", this.ruleForm.username);

              GlobalUtil.setCookie("isChoose", this.isChoose);
              this.isChoose && GlobalUtil.setCookie("saveUsername", this.ruleForm.username);
              this.isChoose && GlobalUtil.setCookie("save1", this.ruleForm.password);

              this.$message.success("登录成功！");
              this.$router.push("/home");
            }
          });
        } else {
          this.$message.error("请输入账号或密码");
          return false;
        }
      });
    },
    codeLogin() {
      if (!this.userName) {
        this.$message.error("请填写正确的手机号！");
        return false;
      } else if (!this.vCode) {
        this.$message.error("请填写获取的验证码");
        return false;
      } else {
        GlobalUtil.getTicket().then(res => {
          if (res.data) {
            this.$axios
              .post(
                this.$url.loginByCode,
                {
                  phone: this.userName,
                  code: this.vCode
                },
                {
                  ticket: res.data
                },
                { headers: { 'Content-Type': 'application/json' } }
              )
              .then(res => {
                if (res.data) {
                  let headers = {
                    sui: res.data.sui,
                    factoryList: res.data.factoryList
                  };
                  let obj = res.data;
                  obj.phone = this.userName;
                  GlobalUtil.setSessionStorage("loginInfo", obj);
                  this.$router.push("/selectFactory");
                }
              });
          }
        });
      }
    },
    login(ticket) {
      this.$axios
        .post(
          this.$url.login,
          {
            phone: this.userName,
            password: this.passWord
          },
          {
            ticket: ticket
          }
        )
        .then(res => {
          if (res.data) {
            let headers = {
              sui: res.data.sui
            };
            // GlobalUtil.setCookie('headers', JSON.stringify(headers))
            let obj = res.data;
            obj.phone = this.userName;
            this.$router.push("/home");
          }
        });
    },
    getVcode() {
      //获取短信验证码
      if (!this.userName) {
        this.$message.error("请填写正确的手机号！");
        return false;
      } else if (this.flag) {
        GlobalUtil.getTicket().then(res => {
          if (res.data) {
            this.$axios
              .post(
                this.$url.getVCode,
                {
                  phone: this.userName,
                  type: 1
                },
                {
                  ticket: res.data
                }
              )
              .then(res => {
                if (res.data) {
                  let loop = 59;
                  let that = this;
                  let clock = setInterval(function () {
                    if (loop >= 0) {
                      that.codeText = loop-- + " S";
                    } else {
                      that.flag = true;
                      that.codeText = "发送";
                      clearInterval(clock);
                    }
                  }, 1000);
                }
              });
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input {
  width: 350px;
}

::v-deep .el-button {
  width: 350px !important;
}

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.login_left {
  width: 66.66%;
  height: 100%;
  background: url("./../assets/img/login/bg_login.jpg") no-repeat;
  background-size: 100% 100%;
  float: left;
}

.login_right {
  width: 33.33%;
  height: 100%;
  float: left;
  position: relative;
}

.ms_login {
  position: absolute;
  top: 41%;
  left: 50%;
  margin-left: -205px;
  margin-top: -140px;
  width: 380px;
  height: 377px;
  padding: 31px;
  box-sizing: border-box;
}

.ms_login-input-content {
  width: 100%;
  height: 42px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 30px;
  background: #fff;
  font-weight: bold;
  display: flex;
}

// .ms_login-input-content::after {
//   content: "";
//   position: absolute;
//   left: 0;
//   bottom: 0;
//   width: 100%;
//   height: 1px;
//   background-color: #dcdee3;
//   z-index: 1;
// }

.password {
  width: 380px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

.save_password {
  display: flex;
  align-items: center;
}

.check_box {
  margin-right: 5px;
  height: 16px;
  width: 16px;
}

.forget {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(89, 204, 225, 1);
  text-align: left;
  margin-right: -90px;
  cursor: pointer;
}

.ms-verify {
  /* float: left; */
  width: 330px;
  overflow: hidden;
  height: 50px;
  color: #000000;
  margin-bottom: 30px;
}

.ms-verify-input {
  float: left;
  width: 180px;
  height: 38px;
  text-indent: 1em;
  color: #000000;
}

.ms-verify-input input {
  color: #000000;
}

.ms-verify-input input::-moz-placeholder {
  color: #000000;
}

.ms-verify-input input::-webkit-input-placeholder {
  color: #000000;
}

.get_code_btn {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 138px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.code_btn {
  width: 100%;
  border: 0px;
}

.login-icon {
  position: relative;
  z-index: 2;
}

.login-icon {
  z-index: 3;
  width: 42px;
  height: 42px;
  background: url("../assets/img/login/phone.png") no-repeat;
  background-size: 42px 42px;
  // position: relative;
  // top: 1px;
}

.user_psd {
  width: 42px;
  height: 42px;
  background: url("../assets/img/login/password.png") no-repeat;
  background-size: contain;
  position: relative;
  top: 1px;
}

.login-input {
  float: left;
  width: 280px;
  height: 40px;
  padding-left: 10px;
  /* border-bottom: 1px solid #DCDEE3; */
}

.login-btn {
  width: 100%;
  margin-bottom: 10px;
}

.login-btn button {
  display: block;
  width: 100%;
  height: 42px !important;
  // background: #1abc9c;
  border-radius: 5px;
}

.ms_title {
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 100px;
}

.login_logo {
  width: 160px;
  height: 50px;
  background: url("../assets/img/login/logo_bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 24px;
  left: 30px;
}

.addXuQiu {
  position: absolute;
  bottom: 12px;
  right: 587px;
  text-align: center;
  cursor: pointer;

  i {
    font-size: 15px;
  }

  &:hover {
    color: #7ad6e7;
  }
}
</style>
